<template>
  <div class="design_1_block">
    <div class="background_gradient">
      <div class="box">
        <div class="container_1">
          <div class="row">
            <div class="col-md-7">
              <p class="design_p_1">{{this.designData.head_tittle}}</p>
              <p class="design_p_2">{{this.designData.head_desc}}</p>
              <p class="btn" @click="this.FEEDBACK_FORM()">Узнать стоимость</p>
            </div>
            <div class="col-md-5 col-xl-5">
              <div class="img_inside"><img :src="require(`@/assets/img/design/${this.designData.img_logo}`)" alt="NIMIRUN DESIGN DEVELOPMENT. Nimirum Дизайн и Разработка"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
  name:'',
  components: {
  },
  data(){
    return{
      id:this.$route.query.info || 1,
    }
  },
  mounted(){
    // console.log(this.designData)
    // console.log(this.$route.query.id)
    // console.log(this.designData)
  },

  created(){
    
  },
  methods:{
    update(){
      this.id = Number.parseInt(to.query.info) || 1
    },
    ...mapMutations({
      FEEDBACK_FORM:'FEEDBACK_FORM',
  }),
  ...mapActions({
  }),
  },
  computed:{
    ...mapGetters([
      'DESIGN_DATA',
  ]),
    designData:function(){
      return this.DESIGN_DATA
    }
  } 
};
</script>

<style scoped>
.img_inside {
  /*background:url("../../assets/img/design/img_1.svg") no-repeat;*/
  width:auto;
  height:100%;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.btn {
  margin:0 0 50px 0;
  font-size:16px;
  color:#fff;
  padding:14px;
  background:#444BD3;
  height:50px;
  width:56%;
  border-radius:8px;
  text-align:center;
  cursor:pointer;
}
.design_p_2 {
  font-size:20px;
  margin:0 0 40px 0;
  max-width:640px;
}
p {
  color:#fff;
}
.design_p_1 {
max-width:646px;
font-size: 30px;
font-weight:600;
margin: 40px 0 40px 0;
}
.container_1 {
  margin-top:53px;
  margin-bottom:120px;
}
.box {
  max-width: 1262px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 15px 0 15px;
}
.background_gradient:before {
      
}
.background_gradient {
  width:100%;
  height:100%;
}
@media(max-width:767px) {
  .img_inside {
  width:100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  }
  .design_p_1 {
    font-size:25px;
  }
  .design_p_2 {
    font-size:16px;
  }
  .container_1 {
    margin-bottom:50px;
  }
}
@media(max-width:641px) {
  .img_inside {
    background-size:64%;
  }
  .btn {
    width:100%;
  }
}
@media(max-width:500px) {
  .img_inside {
    background-size:82%;
  }
}
@media(max-width:400px) {
  .img_inside {
    background-size:100%;
  }
}
</style>